import React, { useState, useRef, useEffect, useContext } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Dialog,
  Divider,
  Grid,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiAutoComplete from "../../controls/MuiAutoComplete";
import MuiDatePicker from "../../controls/MuiDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import from salesSlice.js
import {
  getSalesNoFromServer,
  getOpeningBalanceFromCustomerMaster,
  addSalesDetailsToServer,
  updateSalesDetailsToServer,
} from "./salesSlice";

//Import from customerSlice.js
import {
  getCustomersFromServer,
  selectAllCustomers,
} from "../../masters/customer/customerSlice";

//Import from itemSlice.js
import {
  getItemsFromServer,
  selectAllItems,
} from "../../masters/item/itemSlice";

//Import from uomSlice.js
import { getUoMFromServer, selectAllUoM } from "../../masters/uom/uomSlice";

//Import from SalesContext
import { SalesContext } from "./SalesContext";

//Import React Router Dom
import { useNavigate } from "react-router-dom";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import Pages
import Collection from "../collection/Collection";

//Import CSS
import "./sales.css";

const Sales = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customersList = useSelector(selectAllCustomers);
  const itemsList = useSelector(selectAllItems);
  const uomsList = useSelector(selectAllUoM);
  const signinUser = useSelector(getSignInUser);

  //useContext
  const { setSalesDetailInfoFromContext, salesDetailInfoFromContext } =
    useContext(SalesContext);
  //End useContext

  //useState
  const [loginUser, setLoginUser] = useState(signinUser);
  const [salesNo, setSalesNo] = useState(0);
  const [selectedSalesDate, setSelectedSalesDate] = useState(
    salesDetailInfoFromContext.length === 0
      ? dayjs()
      : dayjs(salesDetailInfoFromContext[0].SalesDate, "DD/MM/YYYY", true)
  );
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [uoms, setUoMs] = useState([]);
  const [selectedUoM, setSelectedUoM] = useState({
    Id: 1,
    UCode: "kg",
    UName: "Kg",
  });
  const [uomCode, setUoMCode] = useState("kg");
  const [uomName, setUoMName] = useState("Kg");
  const [unitPrice, setUnitPrice] = useState("");
  const [tableData, setTableData] = useState([]);
  const [salesItemsCount, setSalesItemsCount] = useState(0);
  const [currentAmount, setCurrentAmount] = useState(parseFloat(0).toFixed(2));
  const [lessAmount, setLessAmount] = useState(parseFloat(0).toFixed(2));
  const [openingBalance, setOpeningBalance] = useState(
    parseFloat(0).toFixed(2)
  );
  const [netAmount, setNetAmount] = useState(parseFloat(0).toFixed(2));
  const [collectionAmount, setCollectionAmount] = useState(
    parseFloat(0).toFixed(2)
  );
  const [buttonSave, setButtonSave] = useState("Save");
  const [save, setSave] = useState(false);
  const [editingRow, setEditingRow] = useState(0);
  // const [isShowChild, setIsShowChild] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // End useState

  // useEffect
  useEffect(() => {
    setSalesDetailInfoFromContext([]);
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => setLoginUser(result.data));
    }

    const fetchDatas = async () => {
      try {
        const getSalesNo = await dispatch(getSalesNoFromServer()).then(
          unwrapResult
        );
        setSalesNo(getSalesNo.data[0].SalesNo);

        // if (customersList !== undefined && customersList.length > 0) {
        //   setCustomers(customersList);
        // } else {
        const customerListsResult = await dispatch(getCustomersFromServer());
        const unwrappedCustomersResult = unwrapResult(customerListsResult);
        setCustomers(unwrappedCustomersResult.data);
        // }

        // if (itemsList !== undefined && itemsList.length > 0) {
        //   setItems(itemsList);
        // } else {
        const itemListsresult = await dispatch(getItemsFromServer());
        const unwrappedItemsResult = unwrapResult(itemListsresult);
        setItems(unwrappedItemsResult.data);
        // }

        // if (uomsList !== undefined && uomsList.length > 0) {
        //   setUoMs(uomsList);
        // } else {
        const uomListsResult = await dispatch(getUoMFromServer());
        const unwrappedUoMResult = unwrapResult(uomListsResult);
        setUoMs(unwrappedUoMResult.data);
        // }
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };
    if (salesDetailInfoFromContext.length === 0) {
      setTimeout(() => {
        fetchDatas();
      }, 1000);
    } else {
      setButtonSave("Update");
      setCustomers(customersList);
      setItems(itemsList);
      setUoMs(uomsList);
      setSalesNo(salesDetailInfoFromContext[0].SalesNo);
      // let parsedDate = dayjs(
      //   salesDetailInfoFromContext[0].SalesDate,
      //   "DD/MM/YYYY",
      //   true
      // );
      // setSelectedSalesDate(parsedDate);
      let customer = customersList.find(
        (customer) => customer.CUCode === salesDetailInfoFromContext[0].CUCode
      );
      setSelectedCustomer(customer);
      setCustomerCode(customer.CUCode);
      setCustomerName(customer.CUName);
      const salesdetailsFromExcerpt =
        salesDetailInfoFromContext[0].SalesDetails.map((salesDetail) => {
          return {
            SNo: salesDetail.SNo,
            Item: salesDetail.IName,
            Quantity: `${parseFloat(salesDetail.Quantity).toFixed(3)} - ${
              salesDetail.UName
            }`,
            Price: parseFloat(salesDetail.UnitPrice).toFixed(2),
            TotalAmount: salesDetail.TotalAmount.toFixed(2),
          };
        });
      setTableData(salesdetailsFromExcerpt);
      setCurrentAmount(
        parseFloat(salesDetailInfoFromContext[0].CurrentAmount).toFixed(2)
      );
      setLessAmount(
        parseFloat(salesDetailInfoFromContext[0].LessAmount).toFixed(2)
      );
      setOpeningBalance(
        parseFloat(salesDetailInfoFromContext[0].OpeningBalance).toFixed(2)
      );
      setNetAmount(
        parseFloat(salesDetailInfoFromContext[0].NetAmount).toFixed(2)
      );
      setCollectionAmount(
        parseFloat(salesDetailInfoFromContext[0].CollectionAmount).toFixed(2)
      );
      // setItemsCount(salesDetailInfoFromContext[0].SalesDetails.length);
      itemsRef.current.focus();
    }
  }, []);

  // Calculate NetAmount whenever currentAmount, lessAmount, or openingBalance changes
  useEffect(() => {
    const netAmountValue = (
      parseFloat(currentAmount) -
      parseFloat(lessAmount) +
      parseFloat(openingBalance)
    ).toFixed(2);
    setNetAmount(netAmountValue);
  }, [currentAmount, lessAmount, openingBalance]);
  //End useEffect

  //useRef
  const salesDateRef = useRef(null);
  const customersRef = useRef(null);
  const itemsRef = useRef(null);
  const quantityRef = useRef(null);
  const uomsRef = useRef(null);
  const unitPriceRef = useRef(null);
  const addRef = useRef(null);
  const refreshRef = useRef(null);
  const clearRef = useRef(null);
  const currentAmountRef = useRef(null);
  const lessAmountRef = useRef(null);
  const openingBalanceRef = useRef(null);
  const netAmountRef = useRef(null);
  const collelctionAmountRef = useRef(null);
  const saveRef = useRef(null);
  const editRef = useRef(null);
  const collectionRef = useRef(null);
  //End useRef

  const handleDateChange = (newValue) => {
    if (newValue && newValue.isValid()) {
      setSelectedSalesDate(newValue);
      setIsDatePickerOpen(false);
    }
  };

  const handleDateBlur = (event) => {
    const inputValue = event.target.value;
    const parsedDate = dayjs(inputValue, "DD/MM/YYYY", true);
    if (!parsedDate.isValid()) {
      // This is required
      // setError({
      //   salesDate: "Enter a valid date in DD/MM/YYYY format",
      //   customerName: "",
      //   itemName: "",
      //   quantity: "",
      //   uomName: "",
      //   unitPrice: "",
      // });
      setSelectedSalesDate(dayjs());
      setIsDatePickerOpen(false);
    } else {
      // This is required
      // setError({ salesDate: "" }); // Clear error if date is valid
      setSelectedSalesDate(parsedDate);
    }
  };

  const handleCustomerChange = async (e, value) => {
    e.preventDefault();
    setSelectedCustomer(value);
    if (value) {
      setCustomerCode(value.CUCode);
      setCustomerName(value.CUName);
      // Remove commas from the OpeningBalance string and convert it to a number
      // const cleanOpeningBalance = parseFloat(
      //   value.OpeningBalance.replace(/,/g, "")
      // );

      await dispatch(getOpeningBalanceFromCustomerMaster(value))
        .then(unwrapResult)
        .then((result) => {
          // let openingBalanceAgainstCustomer = result.data[0];
          // let cleanOpeningBalance = parseFloat(
          //   openingBalanceAgainstCustomer.replace(/,/g, "")
          // );
          setOpeningBalance(
            parseFloat(result.data[0].OpeningBalance).toFixed(2)
          );
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });
      itemsRef.current.focus();
    }
  };

  const handleItemChange = (e, value) => {
    e.preventDefault();
    setSelectedItem(value);
    if (value) {
      setItemCode(value.ICode);
      setItemName(value.IName);
      quantityRef.current.focus();
    }
  };

  const handleUoMChange = (e, value) => {
    e.preventDefault();
    setSelectedUoM(value);
    if (value) {
      setUoMCode(value.UCode);
      setUoMName(value.UName);
      unitPriceRef.current.focus();
    }
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    {
      id: "SNo",
      label: "SNo",
      minWidth: 100,
    },
    { id: "Item", label: "Item", minWidth: 170 },
    { id: "Quantity", label: "Quantity", minWidth: 100 },
    { id: "Price", label: "Price", align: "right", minWidth: 50 },
    {
      id: "TotalAmount",
      label: "Total Amount",
      align: "right",
      minWidth: 50,
    },
  ];

  const handleAddItem = (e) => {
    e.preventDefault();
    if (selectedSalesDate === null) {
      setNotify({
        isOpen: true,
        message: "Date is required",
        severity: "warning",
      });
      salesDateRef.current.focus();
      return;
    } else if (selectedCustomer === null) {
      setNotify({
        isOpen: true,
        message: "Customer is required",
        severity: "warning",
      });
      customersRef.current.focus();
      return;
    } else if (selectedItem === null) {
      setNotify({
        isOpen: true,
        message: "Item is required",
        severity: "warning",
      });
      itemsRef.current.focus();
      return;
    } else if (quantity === "") {
      setNotify({
        isOpen: true,
        message: "Quantity is required",
        severity: "warning",
      });
      quantityRef.current.focus();
      return;
    } else if (selectedUoM === null) {
      setNotify({
        isOpen: true,
        message: "UoM is required",
        severity: "warning",
      });
      uomsRef.current.focus();
      return;
    } else if (unitPrice === "") {
      setNotify({
        isOpen: true,
        message: "Price is required",
        severity: "warning",
      });
      unitPriceRef.current.focus();
      return;
    } else {
      let salesItems;
      const totalAmount = quantity * unitPrice;
      if (editingRow) {
        salesItems = tableData.map((item) =>
          item.SNo === editingRow
            ? {
                ...item,
                Item: itemName,
                Quantity: `${parseFloat(quantity).toFixed(3)} - ${uomName}`,
                Price: parseFloat(unitPrice).toFixed(2),
                TotalAmount: totalAmount.toFixed(2),
              }
            : item
        );
        setTableData(salesItems);
        setEditingRow(0);
      } else {
        let lastSNo = 0;
        if (salesDetailInfoFromContext.length > 0) {
          let lastIndex = tableData.length - 1;
          lastSNo = tableData[lastIndex].SNo;
        }

        const newItem = {
          SNo:
            salesDetailInfoFromContext.length > 0
              ? lastSNo + 1
              : tableData.length + 1,
          Item: itemName,
          Quantity: `${parseFloat(quantity).toFixed(3)} - ${uomName}`,
          Price: parseFloat(unitPrice).toFixed(2),
          TotalAmount: totalAmount.toFixed(2),
        };

        salesItems = [...tableData, newItem];
        setTableData(salesItems);
        setSalesItemsCount(tableData.length + 1);
      }
      //CurrentAmount Calculation
      const newCurrentAmount = salesItems
        .reduce((acc, item) => acc + parseFloat(item.TotalAmount), 0)
        .toFixed(2);
      setCurrentAmount(newCurrentAmount);
      resetfields();
      let selectiveUoM = uoms.find((uom) => uom.UCode === "kg");
      setSelectedUoM(selectiveUoM);
      setUoMCode(selectiveUoM.UCode);
      setUoMName(selectiveUoM.UName);
      itemsRef.current.focus();
    }
  };

  const handleClear = (e) => {
    e.preventDefault();
    resetfields();
    resetamountfields();
    itemsRef.current.focus();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const resetfields = () => {
    setSelectedItem(null);
    setItemCode("");
    setItemName("");
    setQuantity("");
    setSelectedUoM(null);
    setUoMCode("");
    setUoMName("");
    setUnitPrice("");
  };

  const resetamountfields = () => {
    setTableData([]);
    setSalesItemsCount(0);
    setCurrentAmount(parseFloat(0).toFixed(2));
    setLessAmount(parseFloat(0).toFixed(2));
    // if (buttonSave !== "Save" && buttonSave !== "Update") {
    //   setOpeningBalance(parseFloat(0).toFixed(2));
    // }
    setOpeningBalance(parseFloat(0).toFixed(2));
    setNetAmount(parseFloat(0).toFixed(2));
    setCollectionAmount(parseFloat(0).toFixed(2));
  };

  const handleEditItem = (e, data) => {
    e.preventDefault();
    setEditingRow(data.SNo);
    const itemList =
      salesDetailInfoFromContext.length === 0 ? items : itemsList;

    const selectedItem = itemList.find((item) => item.IName === data.Item);

    setSelectedItem(selectedItem);
    setItemCode(selectedItem.ICode);
    setItemName(selectedItem.IName);
    const quantityWithUnit = data.Quantity;
    const [qty, unit] = quantityWithUnit.split(" - ");
    setQuantity(qty);
    const uomList = salesDetailInfoFromContext.length === 0 ? uoms : uomsList;

    const selectedUoM = uomList.find((uom) => uom.UName === unit);
    // const uom = uoms.find((uom) => uom.UName === unit);
    setSelectedUoM(selectedUoM);
    setUoMCode(selectedUoM.UCode);
    setUoMName(selectedUoM.UName);
    setUnitPrice(data.Price);
    quantityRef.current.focus();
  };

  const handleDeleteItem = (e, data) => {
    e.preventDefault();
    const existingDataAfterRemove = tableData.filter(
      (row) => row.SNo !== data.SNo
    );

    // if (salesDetailInfoFromContext.length === 0) {
    setTableData(updateSNo(existingDataAfterRemove));
    // } else {
    //   setTableData(existingDataAfterRemove);
    // }

    setSalesItemsCount(existingDataAfterRemove.length);
    const newCurrentAmount = existingDataAfterRemove
      .reduce((acc, item) => acc + parseFloat(item.TotalAmount), 0)
      .toFixed(2);
    setCurrentAmount(newCurrentAmount);
    setLessAmount(parseFloat(0).toFixed(2));
  };

  const updateSNo = (data) => {
    return data.map((item, index) => ({
      ...item,
      SNo: index + 1,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    validate();
  };

  const validate = async () => {
    if (salesNo === "") {
      setNotify({
        isOpen: true,
        message: "Sales No is required",
        severity: "warning",
      });
      return;
    } else if (selectedSalesDate === null) {
      setNotify({
        isOpen: true,
        message: "Sales Date is required",
        severity: "warning",
      });
      salesDateRef.current.focus();
      return;
    } else if (selectedCustomer === null) {
      setNotify({
        isOpen: true,
        message: "Customer is required",
        severity: "warning",
      });
      customersRef.current.focus();
      return;
    } else if (tableData.length === 0) {
      setNotify({
        isOpen: true,
        message: "Sales details does not exist",
        severity: "error",
      });
      return;
    } else {
      const formatedSalesDate = dayjs(selectedSalesDate).format("DD/MM/YYYY");
      const sumOfQuantities = tableData.reduce(
        (acc, item) => {
          const [qty, unit] = item.Quantity.split(" - ");
          const parsedQuantity = parseFloat(qty);

          if (unit.trim() === "Kg") {
            acc.Kg += parsedQuantity;
          } else if (unit.trim() === "Box") {
            acc.Box += parsedQuantity;
          }
          return acc;
        },
        { Kg: 0, Box: 0 }
      );

      const salesItems = tableData.map((detail) => {
        let [quantity, unit] = detail.Quantity.split(" - ");

        let item = items.find((item) => item.IName === detail.Item);
        let uom = uoms.find((uom) => uom.UName === unit.trim());
        return {
          ...detail, // Keep the other properties
          ItemCode: item.ICode,
          Quantity: quantity.trim(), // Update the QUANTITY to numeric part
          UoMCode: uom.UCode,
          UoMName: unit.trim(), // Add the new UNIT property
        };
      });

      const newSales = {
        salesNo,
        selectedSalesDate: formatedSalesDate,
        customerCode,
        customerName,
        totalQuantityperKg: parseFloat(sumOfQuantities.Kg).toFixed(3),
        totalQuantityperBox: parseFloat(sumOfQuantities.Box).toFixed(3),
        salesDetails: salesItems,
        currentAmount,
        lessAmount,
        openingBalance,
        netAmount,
        collectionAmount,
        loginUser,
      };
      if (buttonSave === "Save") {
        setSave(true);
        await dispatch(addSalesDetailsToServer(newSales))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else if (result.flag === 2) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "warning",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          })
          .finally(() => setSave(false));
      } else {
        setSave(true);
        await dispatch(updateSalesDetailsToServer({ ...newSales, loginUser }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          })
          .finally(() => setSave(false));
        setButtonSave("Save");
        setSalesDetailInfoFromContext([]);
      }

      await dispatch(getSalesNoFromServer())
        .then(unwrapResult)
        .then((result) => {
          setSalesNo(result.data[0].SalesNo);
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });

      // await dispatch(getOpeningBalanceFromCustomerMaster(selectedCustomer))
      //   .then(unwrapResult)
      //   .then((result) => {
      //     setOpeningBalance(
      //       parseFloat(result.data[0].OpeningBalance).toFixed(2)
      //     );
      //   })
      //   .catch((err) => {
      //     console.log({ ErrorOccured: err });
      //     setNotify({
      //       isOpen: true,
      //       message: err.message,
      //       severity: "error",
      //     });
      //   });
      setSelectedCustomer(null);
      setCustomerCode("");
      setCustomerName("");
      resetfields();
      let selectiveUoM = uoms.find((uom) => uom.UCode === "kg");
      setSelectedUoM(selectiveUoM);
      setUoMCode(selectiveUoM.UCode);
      setUoMName(selectiveUoM.UName);
      resetamountfields();
      customersRef.current.focus();
    }
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetfields();
    resetamountfields();
    navigate("/salesedit");
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    validate();
  };

  const handleCollection = () => {
    // setIsShowChild(true);
    navigate("/collection");
  };

  // const handleCloseCollection = () => {
  //   setIsShowChild(false);
  // };

  return (
    <>
      <div className="row">
        <Alert notify={notify} setNotify={setNotify} />
        <Box className="salesboxcontainer">
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            {/* <h6>Add Customer</h6>
            <Divider /> */}
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="salesno"
                    label="Sales No *"
                    InputProps={{
                      readOnly: true,
                    }}
                    value={salesNo}
                    // onChange={(e) => {
                    //   setCustomerCode(e.target.value);
                    // }}

                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MuiDatePicker
                      label="Sales Date"
                      value={selectedSalesDate}
                      onChange={handleDateChange}
                      open={isDatePickerOpen}
                      onClose={() => setIsDatePickerOpen(false)}
                      slotProps={{
                        textField: {
                          onClick: (e) => {
                            // Prevent the default click action and open the picker
                            e.stopPropagation();
                            setIsDatePickerOpen(true);
                          },
                          onBlur: handleDateBlur, // Add onBlur handler
                          inputRef: salesDateRef,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiAutoComplete
                    id="customer"
                    clearOnEscape
                    autoHighlight
                    autoSelect
                    options={customers}
                    getOptionLabel={(option) =>
                      `${option.CUCode} - ${option.CUName}` || ""
                    }
                    value={selectedCustomer}
                    onChange={handleCustomerChange}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        label="Customer *"
                        inputRef={customersRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            salesDateRef.current.focus();
                        }}
                        autoFocus
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiAutoComplete
                    id="item"
                    clearOnEscape
                    autoHighlight
                    autoSelect
                    options={items}
                    getOptionLabel={(option) =>
                      `${option.ICode} - ${option.IName}` || ""
                    }
                    value={selectedItem}
                    onChange={handleItemChange}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        label="Item *"
                        inputRef={itemsRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            customersRef.current.focus();
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="quantity"
                    label="Quantity *"
                    onChange={(e) => {
                      // not allow to enter negative values - /^\d*\.?\d*$/
                      // not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,3}$/)) {
                        setQuantity(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(quantity) ? "" : quantity}
                    inputRef={quantityRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        itemsRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiAutoComplete
                    id="uom"
                    clearOnEscape
                    options={uoms}
                    getOptionLabel={(option) =>
                      `${option.UCode} - ${option.UName}` || ""
                    }
                    value={selectedUoM}
                    onChange={handleUoMChange}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        label="UoM *"
                        inputRef={uomsRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            quantityRef.current.focus();
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="unitprice"
                    label="Unit Price *"
                    onChange={(e) => {
                      // not allow to enter negative values - /^\d*\.?\d*$/
                      // not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setUnitPrice(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(unitPrice) ? "" : unitPrice}
                    inputRef={unitPriceRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        uomsRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    className="btnadd"
                    variant="contained"
                    size="small"
                    ref={addRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        unitPriceRef.current.focus();
                    }}
                    onClick={handleAddItem}
                  >
                    Add
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    className="btnrefresh"
                    variant="contained"
                    size="small"
                    ref={refreshRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        addRef.current.focus();
                    }}
                    onClick={handleRefresh}
                  >
                    Refresh
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    variant="contained"
                    size="small"
                    className="btnclear"
                    ref={clearRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        refreshRef.current.focus();
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
          <div className="row">
            <Box className="col-8" sx={{ mt: 3 }}>
              <Paper className="paper" elevation={2} sx={{ p: 2 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns
                          // .filter((column) => !column.hideable)
                          .map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Important: This MuiTable renders first, and if we don't handle the conditions below, the .slice property will throw an error.
                  Because gendersList will be undefined. While saving new data, I am fetching the Genders List, which contains an array of genders. 
                  Once fetched, it will bind the gendersList to the table. */}

                      {Array.isArray(tableData) && tableData.length > 0 ? (
                        // <>
                        //   {console.log(
                        //     "Rendering gender list" + gendersList.length
                        //   )}
                        //   {
                        tableData.map((item) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={item.SNo}
                            >
                              {columns.map((column) => {
                                const value = item[column.id];
                                if (column.id === "Action") {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      <EditIcon
                                        className="editicon"
                                        fontSize="medium"
                                        onClick={(e) => handleEditItem(e, item)}
                                      />
                                      <DeleteIcon
                                        className="deleteicon"
                                        fontSize="medium"
                                        onClick={(e) =>
                                          handleDeleteItem(e, item)
                                        }
                                      />
                                    </TableCell>
                                  );
                                } else {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                }
                              })}
                            </TableRow>
                          );
                        })
                      ) : (
                        //   }
                        // </>
                        // <>
                        //   {console.log("No Genders found")}
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            No Items found
                          </TableCell>
                        </TableRow>
                        // </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="salesitemscount">
                  Total of {salesItemsCount} items
                </div>
              </Paper>
            </Box>
            <Box className="col-4" sx={{ mt: 3 }}>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sx={{ ml: 1 }}>
                  <MuiTextField
                    type="number"
                    id="currentamount"
                    label="Current Amount *"
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={(e) => {
                      //not allow to enter negative values - /^\d*\.?\d*$/
                      //not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setCurrentAmount(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(currentAmount) ? "" : currentAmount}
                    inputRef={currentAmountRef}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sx={{ ml: 1 }}>
                  <MuiTextField
                    type="number"
                    id="lessamount"
                    label="Less Amount *"
                    onChange={(e) => {
                      //not allow to enter negative values - /^\d*\.?\d*$/
                      //not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setLessAmount(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(lessAmount) ? "" : lessAmount}
                    inputRef={lessAmountRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        unitPriceRef.current.focus();
                    }}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sx={{ ml: 1 }}>
                  <MuiTextField
                    type="number"
                    id="openingbalance"
                    label="Opening Balance *"
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={(e) => {
                      setOpeningBalance(e.target.value);
                    }}
                    value={isNaN(openingBalance) ? "" : openingBalance}
                    inputRef={openingBalanceRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        lessAmountRef.current.focus();
                    }}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sx={{ ml: 1 }}>
                  <MuiTextField
                    type="number"
                    id="netamount"
                    label="Net Amount *"
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={(e) => {
                      setNetAmount(e.target.value);
                    }}
                    value={isNaN(netAmount) ? "" : netAmount}
                    inputRef={netAmountRef}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sx={{ ml: 1 }}>
                  <MuiTextField
                    type="number"
                    id="collectionamount"
                    label="Collection Amount *"
                    onChange={(e) => {
                      //not allow to enter negative values - /^\d*\.?\d*$/
                      //not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setCollectionAmount(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(collectionAmount) ? "" : collectionAmount}
                    inputRef={collelctionAmountRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        lessAmountRef.current.focus();
                    }}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={3} sx={{ ml: 1 }}>
                  {buttonSave === "Save" ? (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnsave"
                      disabled={save}
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          collelctionAmountRef.current.focus();
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnupdate"
                      disabled={save}
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          collelctionAmountRef.current.focus();
                      }}
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    className="btnedit"
                    variant="contained"
                    size="small"
                    ref={editRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        saveRef.current.focus();
                    }}
                    onClick={handleEdit}
                  >
                    Edit
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2.5}>
                  {salesDetailInfoFromContext.length === 0 ? (
                    <Button
                      variant="contained"
                      size="small"
                      className="btncollection"
                      ref={collectionRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          editRef.current.focus();
                      }}
                      onClick={handleCollection}
                    >
                      Collection
                    </Button>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Box>
          </div>
          {/* {isShowChild && <Collection onClose={handleCloseCollection} />} */}
        </Box>
      </div>
    </>
  );
};

export default Sales;
